import { BrandWord } from "./WifiMark";

export const Footer = ({
    email = "void@richoffline.club",
    socials = ["Instagram", "Are.na", "Discord-free"],
    legal = ["Terms", "Privacy", "Shipping"],
    tagline = "No signal. No problem.",
    copyright = "© 2026 Rich Offline Clothing Co.",
}) => (
    <footer className="relative border-t border-zinc-900 px-6 sm:px-12 pt-24 pb-10 overflow-hidden" data-testid="footer">
        <div className="flex flex-col md:flex-row justify-between gap-16 mb-24">
            <div className="max-w-xs">
                <p className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-4">Contact</p>
                <a href={`mailto:${email}`} className="font-serif italic text-xl text-zinc-300 hover:text-signal transition-colors duration-300" data-testid="footer-email">
                    {email}
                </a>
            </div>
            <div className="flex gap-20">
                <div>
                    <p className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-4">Social</p>
                    <div className="flex flex-col gap-2">
                        {socials.map((s) => (
                            <span key={s} className="text-sm text-zinc-400 hover:text-white transition-colors duration-300 cursor-pointer" data-testid={`footer-social-${s.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                                {s}
                            </span>
                        ))}
                    </div>
                </div>
                <div>
                    <p className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-4">Legal</p>
                    <div className="flex flex-col gap-2">
                        {legal.map((s) => (
                            <span key={s} className="text-sm text-zinc-400 hover:text-white transition-colors duration-300 cursor-pointer" data-testid={`footer-legal-${s.toLowerCase()}`}>
                                {s}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>

        <div className="select-none pointer-events-none" aria-hidden="true">
            <p className="font-display font-semibold uppercase tracking-[-0.04em] leading-[0.8] text-[clamp(3.5rem,14vw,15rem)] text-zinc-900 whitespace-nowrap">
                <BrandWord markClassName="opacity-40" />
            </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-2 mt-10 pt-6 border-t border-zinc-900">
            <p className="text-[10px] tracking-[0.25em] uppercase text-zinc-600" data-testid="footer-copyright">
                {copyright}
            </p>
            <p className="text-[10px] tracking-[0.25em] uppercase text-zinc-600">
                {tagline}
            </p>
        </div>
    </footer>
);
